import axios from 'axios';

const DAO_SKLEP_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/sklepy';
const DAO_PRODUCENT_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/producent';

export default function DAOSklepy() {

}
export async function GetProducent(nip) {
    console.log("GetProducent nip:" + nip);
    const res = await axios(DAO_PRODUCENT_URL, {
        method: 'POST',
        withCredentials: false,
        headers: {
            'Accept': 'application/json'
        },
        data: {operacja:"producent",nip:nip}
    }).then((response) => {
        console.log("resp.GetProducent:" + JSON.stringify(response.data));
        if (typeof (response.data.error) != 'undefined') {
            console.log("show error" + response.data.error.info);
            return response.data;
        }
        return response.data;
    }).catch(err => console.log(err.message));
    return res;
}

export function getProducentStorage() {
    const producentString = sessionStorage.getItem('producent');
    if (producentString === null || producentString === "")
        return null;
    console.log(producentString);
    return JSON.parse(producentString)
}